import { useEffect, useState, useCallback } from 'react'
import { widgetService } from '../../../services/widgets-service';
import { showErrorNotification } from '../../admin/common/NotiService';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';

const REFRESH_INTERVAL: number = 5000; // 5 seconds
let intervalId: NodeJS.Timeout;

export default function useAgentDetailsPopUp({ rowData }: { rowData: any }) {
    const [agentStatsData, setAgentStatsData] = useState<{ AgentName?: string; AgentId?: string; tableData: any[]; loading: boolean, lastUpdated: string | null, AgentState?: string, AgentUniqueId?: string }>({ AgentName: '', AgentId: '', tableData: [], loading: false, lastUpdated: null, AgentState: '', AgentUniqueId: '' });
    const fetchAgentCampaignSkillStats = useCallback(async (agentId: string, agentUniqueId: string) => {
        try {
            let resp = await widgetService({
                bodyParams: {
                    apiId: 3001,
                    agentId: agentId,
                    agentUniqueId: agentUniqueId || ''
                }, method: 'POST'
            });
            if (resp && resp.data && Array.isArray(resp.data)) {
                resp.data = resp.data.map((item: any) => ({
                    ...item,
                    QueueCalls: Math.max(0, item["Customer Answered"] - item["Agent Answered"])
                }));
            }
            return resp;
        } catch (e) {
            console.error("Error fetching agent campaign/skill stats:", e);
        } return [];
    }, []);

    const handleAgentNameClick = useCallback(async (row: any) => {
        if (agentStatsData.loading) return;
        try {
            setAgentStatsData((prev) => ({ ...prev, AgentName: row?.AgentName, AgentId: row?.AgentId, AgentState: row?.AgentState, AgentUniqueId: row?.AgentUniqueId }));
        } catch (e) {
            console.error('Failed to load agent stats', e);
            showErrorNotification('Failed to load agent stats');
            setAgentStatsData({ AgentName: '', AgentId: '', tableData: [], loading: false, lastUpdated: null, AgentState: '', AgentUniqueId: '' });
        }
    }, []);

    const closeAgentPopUp = useCallback(() => {
        setAgentStatsData({ AgentName: '', AgentId: '', tableData: [], loading: false, lastUpdated: null, AgentState: '', AgentUniqueId: '' });
    }, []);


    const refreshAgentDetails = useCallback(async (agentStatsData: any) => {
        if (agentStatsData.loading || !agentStatsData.AgentId) return;
        try {
            setAgentStatsData((prev) => ({ ...prev, loading: true }));
            const agentDataResp: any = await fetchAgentCampaignSkillStats(agentStatsData.AgentId, agentStatsData?.AgentUniqueId);
            setAgentStatsData((prev) => ({
                ...prev,
                tableData: Array.isArray(agentDataResp?.data) ? agentDataResp.data : [],
                lastUpdated: getLastFetchedDetailFromBrowser(),
                loading: false
            }));
        } catch (e) {
            console.error('Failed to refresh agent stats', e);
            showErrorNotification('Failed to refresh agent stats');
            setAgentStatsData((prev) => ({ ...prev, loading: false }));
        }
    }, []);

    // Auto-refresh agent details at regular intervals
    useEffect(() => {
        console.log("useEffect - agentStatsData.AgentId:", agentStatsData);
        if (agentStatsData.AgentId) {
            refreshAgentDetails(agentStatsData);
            intervalId = setInterval(() => refreshAgentDetails(agentStatsData), REFRESH_INTERVAL);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [agentStatsData.AgentId]);

    useEffect(() => {
        try {
            if (rowData && Array.isArray(rowData)) {
                const agentData = rowData?.find((item: any) => item?.AgentId === agentStatsData.AgentId);
                if (agentData) {
                    setAgentStatsData((prev) => ({ ...prev, AgentState: agentData.AgentState }));
                }
            }
        } catch (e) {
            console.error('Failed to update agent state', e);
        }
    }, [rowData]);

    return {
        setAgentStatsData,
        agentStatsData,
        handleAgentNameClick,
        closeAgentPopUp
    }
}